import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import PageLayout from '../../../layouts/PageLayout';
import OperatorTableEnhanced from './components/OperatorTableEnhanced';
import OperatorAddModal from './components/OperatorAddModal';

import { openOperatorAddModal } from './actions';
import { routerProps } from '../../../propTypes';

const propTypes = exact({
  openOperatorAddModalAction: PropTypes.func.isRequired,
  ...routerProps,
});

const OperatorList = (props) => {
  const { openOperatorAddModalAction } = props;
  const renderPage = () => {
    return (
      <React.Fragment>
        <Row>
          <Col md={12}>
            <div className="pull-right">
              <Button bsStyle="primary" onClick={() => { openOperatorAddModalAction(); }}>Add Operator</Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <OperatorTableEnhanced />
          </Col>
        </Row>
        <OperatorAddModal />
      </React.Fragment>
    );
  };

  return (
    <PageLayout
      title="Operator List"
      render={renderPage}
    />
  );
};

OperatorList.propTypes = propTypes;

const mapDispatchToProps = {
  openOperatorAddModalAction: openOperatorAddModal,
};

const enhance = connect(null, mapDispatchToProps);

export default enhance(OperatorList);
